var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationSetCreat({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u56FE\\u5C42_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 9 9",
    style: {
      enableBackground: "new 0 0 9 9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "\\u5F62\\u72B6\\u7ED3\\u5408",
    className: "st0",
    d: "M4.5,0C4.8,0,5,0.2,5,0.5V4h3.5C8.8,4,9,4.2,9,4.5S8.8,5,8.5,5H5v3.5C5,8.8,4.8,9,4.5,9 S4,8.8,4,8.5V5H0.5C0.2,5,0,4.8,0,4.5S0.2,4,0.5,4H4V0.5C4,0.2,4.2,0,4.5,0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationSetCreat);
export default __webpack_public_path__ + "static/media/location_set_creat.f4dcc0752ec52a9207cf23ffa69e0828.svg";
export { ForwardRef as ReactComponent };